import { useQuery } from '@tanstack/vue-query';
import { useAuthStore } from '@/store/auth';
import { queries } from '~/keys';

export type AccountManagerCard = {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  photoUrl: string | null;
  languages: string[];
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

const optionalAuthHeaders = (): Record<string, string> => {
  const authStore = useAuthStore();
  return authStore.token ? { Authorization: `Bearer ${authStore.token}` } : {};
};

export const useCurrentAccountManager = () => {
  const { locale } = useI18n();

  return useQuery({
    // Reactive key: a locale switch refetches (guests get a language-aware AM).
    queryKey: computed(() => queries.accountManager.current(locale.value).queryKey),
    queryFn: () =>
      $fetch<{ data: AccountManagerCard | null }>('/api/account-manager', {
        headers: optionalAuthHeaders(),
        query: { locale: locale.value },
      }),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};
